import React from "react";

function Image() {
  return <img src={"../../assets/images/" + this.props.src} />;
}

export default Image;
